import { InternalError, type InternalErrorPayload } from '@/core/shared/errors/internal.error';

/**
 * Manual outreach (and recruiter resume upload) was rejected with a 409 because
 * the candidate already has an application for this job in a status past the
 * early-outreach phase. The outreach request was not sent — surface to the user.
 */
export class ExistingApplicationConflictError extends InternalError {
  constructor(payload: InternalErrorPayload = {}) {
    super('Candidate already has an active application', payload);
  }
}
